import { render, staticRenderFns } from "./ReworksCalendarCard.vue?vue&type=template&id=1c7de15a"
import script from "./ReworksCalendarCard.vue?vue&type=script&lang=js"
export * from "./ReworksCalendarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports